/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getCommonEntityData
 */

import {
  APARTMENT_TYPE_GROUP,
  CONDO_TYPE_GROUP,
  HOUSE_TYPE_GROUP,
  ROOM_TYPE_GROUP,
} from '@zcode-ui/filters'
import { PropertyType, getEnumTitle } from '@zcode/enums'

export const getPropertyTypeTitle = (propertyType: PropertyType | null | undefined) => {
  if (!propertyType) {
    return ''
  }

  if (APARTMENT_TYPE_GROUP.includes(propertyType)) {
    return 'Apartment'
  }

  if (HOUSE_TYPE_GROUP.includes(propertyType)) {
    return 'House'
  }

  if (CONDO_TYPE_GROUP.includes(propertyType)) {
    return 'Condo'
  }

  if (ROOM_TYPE_GROUP.includes(propertyType)) {
    return 'Room'
  }

  return getEnumTitle(PropertyType, propertyType)
}
